<template>

    <div>
        <trax-ui-simple-table :id="id" :titles="titles" :header="1" :header-color="headerColor" :cols="cols">
        </trax-ui-simple-table>

        <div class="ml-3" v-if="selectable && count">
            <trax-ui-checkbox :text="lang.polaris.form.select_all" :value="selectAllChecked" @input="selectAll">
            </trax-ui-checkbox>
        </div>

        <slot v-if="selectable && count"></slot>
    </div>
    
</template>

<script>
    import tableState from './tableState'

    export default {

        props: {
            id: null,
            titles: null,
            props: null,
            endpoint: null,
            endpointParams: null,
            cols: null,
            header: { default: 1 },
            headerColor: { default: 'primary' },
            paging: { default: 1 },
            pageLength: { default: 10 },
            searching: { default: 1 },
            initFilters: null,
            lengthChange: { default: 1 },
            emptyMessage: null,
            orderColumn: null,
            orderDir: null,
            saveState: { default: true },
            stateKey: null,
            stateScope: null,
            selectable: { default: false },
            value: null,
            bus: null
        },

        data: function() {
            return {
                lang: lang,
                dataTable: null,
                filters: {},
                externalFilters: null,
                selectAllChecked: false,
                count: 0,
            };
        },

        computed: {

            computedFilters() {
                if (this.externalFilters) return this.externalFilters;
                if (this.initFilters) return this.initFilters;
                return {};
            },

            order() {
                return this.orderColumn && this.orderDir ? [[this.orderColumn, this.orderDir]] : [];
            },

            params () {
                return this.endpointParams ? this.endpointParams : {};
            },
        },

        created() {
            if (this.bus) {
                this.bus.$on(this.id+'-refresh', this.refresh);
                this.bus.$on(this.id+'-filter', this.filter);
            }
        },
        
        mounted() {
            this.init(); 
        },

        methods: {
        
            selectAll(selected) {
                this.selectAllChecked = selected
                let selection = []
                if (selected) {
                    $('#'+this.id+'-table').DataTable().rows().data().each(function(item, index) {
                        selection.push(item.id)
                    });
                    $('#'+this.id+'-table tbody .row-checkbox').prop('checked', true);
                } else {
                    $('#'+this.id+'-table tbody .row-checkbox').prop('checked', false);
                }
                this.$emit('input', selection)
            },

            checkboxHtml(id) {
                let html = '<div class="form-check" style="width:30px">'
                html += '       <label class="form-check-label">'
                html += '           <input type="checkbox" class="row-checkbox form-check-input" data-id="' + id + '"/>'
                html += '           <span class="form-check-sign">'
                html += '               <span class="check"></span>'
                html += '           </span>'
                html += '       </label>'
                html += '   </div>'
                return html
            },

            initSelectionColumn() {
                if (!this.selectable) {
                    return
                }

                // Adapt the column margin.
                $('#'+this.id+'-table td:first-child').each(function(index, el) {
                    el.style.setProperty('padding-left', '0', 'important');
                });
            },

            refreshSelectionColumn() {
                if (!this.selectable) {
                    return
                }

                // Count the rows, we need it.
                this.count = $('#'+this.id+'-table').DataTable().rows().data().length

                // Reset the interface.
                this.selectAll(false)
            },

            init() {
                var that = this;

                // Initialize datatable

                $.fn.dataTable.ext.errMode = function (settings, help_page_number, message) {
                    console.log('DataTables error: '+message);
                };

                $.fn.dataTable.render.ellipsis = function (cutoff) {
                    return function ( data, type, row ) {
                        return type === 'display' && data && data.length > cutoff ?
                            data.substr(0, cutoff) +'…' :
                            data;
                    }
                };

                var settings = this.settings();
                var datatableSettings = {
                    serverSide: true,
                    deferRender: true,
                    processing: false,
                    ajax: {
                        url: that.endpoint,
                        data: function(data) {
                            data.filters = that.filters;
                            Object.keys(that.params).forEach(function(key) { data[key] = that.params[key]; });
						},
                    },
                    columns: settings.columns,
                    ordering: settings.ordering,
                    order: that.order,
                    language: lang.polaris.datatables,
                    info: false,
                    paging: parseInt(that.paging),
                    pageLength: parseInt(that.pageLength),
                    searching: parseInt(that.searching),
                    lengthChange: parseInt(that.lengthChange),
                    drawCallback: function () {
                        $('.dataTables_paginate > .pagination').addClass('pagination-'+that.headerColor);
                        that.initSelectionColumn()
                    }
                };
                Object.assign(datatableSettings, tableState(that, {
                    save: that.saveState, key: that.stateKey, scope: that.stateScope
                }));
                if (that.emptyMessage) datatableSettings.language.zeroRecords = that.emptyMessage;
                if (that.selectable) {
                    datatableSettings.responsive = false
                    datatableSettings.autoWidth = false
                }
                that.dataTable = $(that.$el).find('table').DataTable(datatableSettings);

                // Change search trigger event (key up > enter)
                
                $('#'+that.id+'-table_filter input[type=search]').unbind();
                $('#'+that.id+'-table_filter input[type=search]').bind('keyup', function(e) {
                    if(e.keyCode == 13) {
                        that.dataTable.search(this.value).draw();   
                    }
                });

                // Hide the header manually when required, because we need to apply <th> width in our own way.

                if (!parseInt(this.header)) {
                    $('#'+that.id+'-table th').each(function(index, el) {
                        el.style.setProperty('padding', '0', 'important');
                        el.style.setProperty('border-bottom', 'none', 'important');
                    });
                }

                // Adapt the select cells.

                if (this.selectable) {

                    // Click on checkbox.

                    $('#'+that.id+'-table').on( 'click', '.row-checkbox', function() {
                        let id = $(this).data('id')
                        let selection = [...that.value]
                        if ($(this).is(':checked')) {
                            selection.push(id)
                        } else {
                            selection.splice(selection.indexOf(id), 1)
                        }

                        that.selectAllChecked = false
                        that.$emit('input', selection);
                    });

                    // Refresh selection after each load.

                    $('#'+that.id+'-table').on( 'draw.dt', function() {
                        that.refreshSelectionColumn()
                    });
                }
            },

            settings() {
                var that = this;
                var ordering = false;
                var columns = [];
                // Selection column
                if (this.selectable) {
                    columns.push(
                        {data: null, name: 'selection', orderable: false, searchable: false, width: "10px", render: function(data, type, row, meta) {
                            return that.checkboxHtml(row.id)
                        }}
                    );
                }
                for (var index in this.props) {
                    var prop = this.props[index];
                    if (typeof prop.source === "function") {
                        if (prop.order == undefined) {
                            var cell = {data: null, name: prop.source.name, orderable: false, render: prop.source};
                        } else {
                            ordering = true;
                            var cell = {data: null, name: prop.order, render: prop.source};
                        }
                    } else {
                        if (prop.orderable === undefined || prop.orderable) {
                            ordering = true;
                            var cell = {data: prop.source, name: prop.source, defaultContent: ''};
                        } else {
                            var cell = {data: prop.source, name: prop.source, defaultContent: '', orderable: false};
                        }
                        if (prop.truncate) cell.render = $.fn.dataTable.render.ellipsis(prop.truncate);
                    }
                    if (prop.class) cell.className = prop.class;
                    if (prop.width) cell.width = prop.width;
                    columns.push(cell);
                }
                return {columns: columns, ordering: ordering};
            },

            refresh() {
                this.dataTable.ajax.reload(null, true);
            },

            filter(filters) {
                this.filters = filters ? filters : {};
                this.refresh();
            }
        }
    }
</script>

<style scoped>

    table {
        table-layout: fixed !important;
    }

</style>

